import MenuBlock from './MenuBlock';

export { MenuBlock };
export default MenuBlock;
